var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-breadcrumb',{attrs:{"routes":_vm.routes,"separator":">"},scopedSlots:_vm._u([{key:"itemRender",fn:function(ref){
var route = ref.route;
var params = ref.params;
var routes = ref.routes;
var paths = ref.paths;
return [(routes.indexOf(route) === routes.length - 1)?_c('span',[_vm._v("\n      "+_vm._s(route.meta.name)+"\n    ")]):_c('router-link',{attrs:{"to":route.path}},[_vm._v("\n      "+_vm._s(route.meta.name)+"\n    ")])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c0266fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/breadcrumb.vue
// module id = null
// module chunks = 